<template>
  <div>
    <b-modal id="modal-delivery-record"
            ref="delivery-record-modal"
            size="xl"
            title="狀態更新紀錄"
            centered
            :content-class="'list-modal-content'"
            :dialog-class="'list-modal-dialog'"
            :body-class="'list-modal-body'"
            :header-class="'list-modal-header'"
            :title-class="'list-modal-title'"
            hide-footer>
              <section class="table-content">
                <DataTable
                  v-show="list"
                  :fields="fields"
                  :mobileFields="mobileFields"
                  :items="list"
                  :total-result="total"
                  :options.sync="options"
                  :loading="loading"
                  @row-selected="onRowSelected"
                  showRowDetails
                >
                  <template v-slot:cell(status)="{ value }">
                    <span v-if="value === 'DELIVERED'" style="color: #0E7DE4">
                      已發貨
                    </span>
                    <span v-else style="color: #EE2727">
                      發貨延誤
                    </span>
                  </template>

                  <!-- mobile only -->
                    <template v-slot:password>
                      ・・・・・・
                    </template>
                    <template v-slot:status="{ value }">
                      <StatusLabel :item="value"></StatusLabel>
                    </template>
                    <template v-slot:id="{ item }">
                      <div class="mobile-edit-wrapper" @click="handleEdit(item, item.id)">
                        <ButtonSubMerchant :type="'edit'"
                                            class="mobile-edit"
                                            :id="subMerchantId">
                        </ButtonSubMerchant>
                      </div>
                    </template>
                  <!-- end of mobile only-->
                  <b-skeleton-table v-if="!list" :rows="15" :columns="5"></b-skeleton-table>
                </DataTable>
            </section>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {
  BModal,
  BSkeletonTable,
} from 'bootstrap-vue';
import {
  switchMap, mergeAll, debounceTime, map, pluck,
} from 'rxjs/operators';
import { scheduled, asyncScheduler } from 'rxjs';
import dataTableMixin from '@/mixins/data-table';
import DataTable from '@/components/DataTable.vue';

export default {
  mixins: [dataTableMixin],
  props: ['redemptionId'],
  data: () => ({
    fields: [
      { key: 'status', label: '狀態', sortable: false },
      { key: 'createdAt', label: '更新時間', sortable: false },
      { key: 'remarks', label: '備註', sortable: false },
    ],
    mobileFields: [
      { key: 'status', label: '狀態', sortable: false },
      { key: 'createdAt', label: '更新時間', sortable: false },
    ],
    options: {
      page: 1,
      size: 15,
      order: 'desc',
    },
    selected: [],
    loading: false,
    id: '',
    item: [],
    windowWidth: window.innerWidth,
  }),
  computed: {
    ...mapGetters(['role']),
    ...mapState(['user']),
    isMobile() {
      const mobileBreakPoint = 1096;
      return this.windowWidth <= mobileBreakPoint;
    },
  },
  components: {
    BModal,
    DataTable,
    BSkeletonTable,
  },
  methods: {
    hideModal() {
      this.$refs['password-modal'].hide();
    },
    initialize() {
      this.oldPassword = null;
      this.newPassword = null;
      this.confirmNewPassword = null;
    },
    onRowSelected(items) {
      this.selected = items;
    },
    handleEdit(item, id) {
      this.item = item;
      this.subMerchantId = id;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  domStreams: ['onSubmit$'],
  subscriptions() {
    const getData$ = (data) => this.httpRequest$({
      method: 'GET',
      url: `/agc-${this.role}-api/salesorder/listDeliveryStatus`,
    }, data);

    return {
      list: scheduled([
        ...this.scheduleTasks,
      ], asyncScheduler).pipe(
        mergeAll(),
        debounceTime(250),
        map(() => ({
          data: {
            ...this.filter,
            redemptionId: this.redemptionId,
          },
          options: this.options,
        })),
        pluck('data'),
        switchMap(getData$),
      ),
    };
  },
  created() {
    window.addEventListener('resize', this.onResize);
  },
};
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/transition/slide";

  ::v-deep {
  .list-modal {
    &-content {
      border: none;
    }

    &-dialog {
      max-width: 1050px;
    }

    &-title {
      font-size: 18px;
      font-weight: 400;
      width: 100%;
    }

    &-header {
      padding: 24px;
      border-bottom: none;
      text-align: center;
    }

    &-header .close {
      font-size: 19px;
      padding-top: 20px;
    }

    &-body {
      padding: 0 24px 24px 24px !important;

      .form-control {
        padding: 12px 14px !important;
        font-size: 15px !important;
        height: 100%;
        border: 1px solid #ced4d9;
      }
      .px-3 {
        padding-top: 8px;
      }
      .btn {
        @include respond(tab-landscape) {
          float: left;
        }
        &-light {
          margin-right: 12px !important;
          background-color: #f9f9fa;
          border: 1px solid #dde1e5;
          color: #636d77;
        }
      }
    }
  }
   .form-control {
    &::-moz-placeholder {
      color: #7e8b93;
      opacity: 1;
      font-weight: 300;
    }
    &:-ms-input-placeholder {
      color: #7e8b93;
      opacity: 1;
      font-weight: 300;
    }
    &::placeholder {
      color: #7e8b93;
      opacity: 1;
      font-weight: 300;
    }
  }
  .data-table{
    .right-corner{
      right: 20%;
    }
    div {
      overflow: initial !important;
    }
    .mobile-edit-wrapper{
      width: 100%;
      position: relative;
      .mobile-edit{
        right: 5px;
        bottom: 10px;
        position: absolute;
      }
    }
  }

  .icon-sub-merchant {
    width: 21px;
    background-image: url(../../assets/img/icon/merchant.svg);
  }
  }
</style>
